<template>
  <div class="seller">
    <buyerHeader v-if="showTitle" />
    <div class="clear pad30_b" :class="{ w1200: showTitle }">
      <sellerMenu class="float-left mar20_r" v-if="showTitle && sellerMenuVisible" />
      <div :class="{ buyer_main: showTitle && sellerMenuVisible }">
        <router-view />
      </div>
    </div>
    <buyerFooter v-if="showTitle" />
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>
<script>
import { mapState } from "vuex";
import sellerMenu from "@/components/buyerMenu";
import buyerHeader from "@/components/buyerHeader";
import buyerFooter from "@/components/buyerFooter";

export default {
  name: "seller",
  components: {
    buyerHeader,
    buyerFooter,
    sellerMenu,
  },
  data() {
    return {};
  },
  computed: mapState({
    showTitle: (state) => state.app.showTitle,
    sellerMenuVisible: (state) => state.app.sellerMenuVisible,
  }),
  created() {
    const { isShowTitle } = this.$route.query;
    // this.$store.dispatch("header/getIsShowShopHead", { isShowTitle: isShowTitle && isShowTitle === "1" ? "1" : "" }).then((res) => {
    //   this.$store.commit("app/setShowTitle", res);
    // });

    if (isShowTitle && isShowTitle === "1") {
      this.$store.commit("app/setShowTitle", false);
    }
  },
};
</script>
